import type { PopupType } from './types';

export class State {
  public popups: PopupType[];
  public gloading: {
    active: boolean;
    text: string;
  };
  public showDropdown: boolean;

  constructor() {
    this.popups = [];
    this.gloading = {
      active: false,
      text: '',
    };
    this.showDropdown = false;
  }
}

const state = new State();

export default state;
